import React, { Component } from 'react';
import {
    Container,
    Title,
    Item
} from './ShareDialog.style';
import { Dialog } from "@material-ui/core";
import Button from '../../../Common/VMButton';
import i18n from '../../../i18n';
class ShareDialog extends Component {
    render() {
        const { open, onClose, onShare } = this.props
        return (
            <Dialog open={open} onClose={onClose}>
                <Container>
                    <Title>{i18n.t("web.myvideo.share")}</Title>
                    <Item onClick={() => onShare("twitter")}>
                        <img src="https://front.videomonster.com/images-7cuytg20/mobile/share_twitter_icon.png" alt="twitter"></img>
                        {i18n.t("web.myvideo.share.twitter")}
                    </Item>
                    <Item onClick={() => onShare("facebook")}>
                        <img src="https://front.videomonster.com/images-7cuytg20/mobile/share_fb_icon.png" alt="facebook"></img>
                        {i18n.t("web.myvideo.share.facebook")}
                    </Item>
                    <Item onClick={() => onShare("link")}>
                        <img src="https://front.videomonster.com/images-7cuytg20/mobile/share_link_icon.png" alt="twiter"></img>
                        {i18n.t("web.myvideo.share.link")}
                    </Item>
                    <Button style={{margin: "30px auto 0 auto"}} 
                    onClick = {onClose}
                    width = {"100px"}
                    height = {"30px"}>
                    {i18n.t("global.cancel")}
                    </Button>
                </Container>
            </Dialog>
        );
    }
}

export default ShareDialog;